var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_1739","data-name":"Rectangle 1739","width":"30","height":"30","rx":"15","fill":"#ffffff","key":0}),React.createElement("path",{"id":"Icon_awesome-search","data-name":"Button awesome-search","d":"M13.81,12.106,11.083,9.38a.656.656,0,0,0-.465-.191h-.446a5.685,5.685,0,1,0-.984.984v.446a.656.656,0,0,0,.191.465l2.726,2.726a.654.654,0,0,0,.927,0l.774-.774A.659.659,0,0,0,13.81,12.106ZM5.688,9.188a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,5.688,9.188Z","transform":"translate(8 8)","fill":"#212121","key":1})]);
}

Search.defaultProps = {"id":"icon_tìm_kiếm","data-name":"icon tìm kiếm","width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Search;

Search.default = Search;
